import BaseModule from './BaseModule'
import Swiper from 'swiper'

/** SwiperWrapper
* Implements iDangerous Swiper
*/
class SwiperWrapper extends BaseModule {
    constructor(o) {
        super(o);
        const elId = this.$el.attr('id') || 'swiper-' + o.id;
        this.$el.attr('id', elId);

        this.enable();
    }

    enable () {
        super.enable();
        this.onTransitionStart = this.onTransitionStart.bind(this);
        this.onSlideChangeTransitionStart = this.onSlideChangeTransitionStart.bind(this);
        this.onTransitionEnd = this.onTransitionEnd.bind(this);

        let swiperOptions = {
            slidesPerView: 1,
            centeredSlides: false,
            spaceBetween: 10,
            observer: true,
            freeMode: false,
            effect: 'slide',
            grabCursor: true,
            updateOnWindowResize: true,
            on: {
                transitionStart: this.onTransitionStart, // for thumbs nav
                slideChangeTransitionStart: this.onSlideChangeTransitionStart,
                slideChangeTransitionEnd: this.onTransitionEnd,
                resize: this.onAppResize.bind(this)
            }
        };

        this.swiperOptions = Object.assign(swiperOptions, this.$el.data('swiperOptions') || {});

        // display slides if slides are hidden
        this.$el.find('.swiper-slide[style="display:none;"]').removeAttr('style');

        this.swiperInstance = new Swiper(this.el, this.swiperOptions);

        if (swiperOptions.equalHeightSlides) {
            this.$el.find('.swiper-slide').css({ 'height': '100%' });
        }

        Z.on('AppResize', this.onAppResize.bind(this));
    }

    next (speed, runCallbacks) { this.swiperInstance.slideNext(speed, runCallbacks); }
    prev (speed, runCallbacks) { this.swiperInstance.slidePrev(speed, runCallbacks); }
    on (event, handler) { this.swiperInstance.on(event, handler); }
    destroy () {
        if (this.swiperInstance) this.swiperInstance.destroy(true, false);
    }

    get slide () { return this.swiperInstance.slides[this.index]; }

    onAppResize () {
        if (this.swiperOptions.equalHeightSlides) {
            this.$swiperWrapper = this.$el.find('.swiper-wrapper');
            this.$swiperWrapper.css({ height: 'auto' });
            this.$swiperWrapper.css({ height: this.$el.outerHeight() });
        }
    }

    onTransitionStart (e) {
        if (!this.swiperInstance) return;
    }

    onSlideChangeTransitionStart (e) {
        if (!this.swiperInstance) return;
    }

    onTransitionEnd (e) {
        if (!this.swiperInstance) return;
    }

    onSwiperTransitionStart (swiper) {
        if (!this.swiperInstance || swiper == this || swiper.index == this.index) return;
        this.swiperInstance.slideTo(swiper.index);
    }
}

export default SwiperWrapper
